<template>
	<section class="promotions seasons main-content align-center">
		<div class="row row-header align-center">
			<h2 class="subtitle">{{ subtitle }}</h2>
			<h2>{{ header }}</h2>
		</div>

		<div class="row promotions-row flex-row slide-row">
			<div ref="emblaCarousel" class="embla">
				<div class="embla__container">
					<nuxt-link
						v-for="season in items"
						:key="season.ID"
						:to="localePath(`/${season.link}`)"
						class="columns column6 slick-slide slick-item embla__slide fade-animate up"
					>
						<div class="slick-slide-content">
							<h3>{{ season.header }}</h3>
							<span>
								{{ season.button }}
								<font-awesome-icon icon="fa-light fa-arrow-right-long" size="1x" />
							</span>
						</div>
						<picture>
							<source v-if="season.imageWebp" :srcset="season.imageWebp" type="image/webp" />
							<source :srcset="season.image" />
							<img loading="lazy" :src="season.image" :alt="season.imageAlt" />
						</picture>
					</nuxt-link>
				</div>
			</div>
		</div>

		<div class="embla-controls">
			<div class="row">
				<div class="columns column12">
					<div
						v-for="(_, index) in 4"
						:key="index"
						class="slider-button"
						:class="{ active: selectedScrollSnap === index }"
						@click="scrollCarouselTo(index)"
					/>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
import emblaCarouselVue from 'embla-carousel-vue';
import Autoplay from 'embla-carousel-autoplay';

const localePath = useLocalePath();

defineProps({
	subtitle: { type: String, default: '' },
	items: { type: Array, default: () => [] },
	header: { type: String, default: '' },
});

const [emblaCarousel, emblaApi] = emblaCarouselVue({ loop: false, duration: 20 }, [Autoplay({ delay: 8000 })]);
const selectedScrollSnap = ref(0);
const scrollCarouselTo = (index) => {
	emblaApi.value.scrollTo(index);
	selectedScrollSnap.value = emblaApi.value.selectedScrollSnap();
};

onMounted(() => {
	if (!emblaApi.value) {
		return;
	}

	emblaApi.value.on('select', () => {
		selectedScrollSnap.value = emblaApi.value.selectedScrollSnap();
	});
});
</script>

<style lang="scss" scoped>
.slick-slide {
	position: relative;
	margin: 2% 2% 2% 0;
	padding: 0;
	width: 48%;
	max-width: none;
}

.slick-slide-content {
	max-width: 460px;
}

.row-header {
	max-width: 980px;
}

@media (max-width: 1080px) {
	.slick-item {
		margin: 0 1% 6%;
	}
}

@media (min-width: 681px) {
	.embla-controls {
		display: none;
	}
}

@media (max-width: 680px) {
	.embla {
		overflow: visible;
		position: relative;

		.slide-row {
			overflow: hidden;
		}
	}

	.embla-controls {
		.row {
			max-width: 100%;
			margin: 35px auto 0;
		}

		.column12 {
			padding: 0;
			display: flex;
			flex-flow: row wrap;
			justify-content: center;
		}

		.slider-button {
			width: 15px;
			height: 15px;
			border: 2px solid #5c936d;
			margin: 0 3px;
			background: none;
			outline: none;
			transition: all 0.3s ease-in-out;
			cursor: pointer;
			text-align: center;

			&:hover,
			&.active {
				background: $cta-color;
			}
		}
	}

	/* stylelint-disable */
	.embla__container {
		display: flex;
		align-items: flex-end;
	}

	.embla__slide {
		flex: 0 0 90%;
		min-width: 0;
		margin: 0 5%;
		text-align: center;
		position: relative;

		&:hover {
			&::before {
				opacity: 0;
			}
		}

		img {
			height: auto;
			z-index: 1;
			position: relative;
		}
	}
	/* stylelint-enable */
}
</style>
